export class ListAllRegionsResponseRegions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "AWS",
            "baseName": "AWS",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "AZURE",
            "baseName": "AZURE",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "GCP",
            "baseName": "GCP",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "MONGO_ATLAS",
            "baseName": "MONGO_ATLAS",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "PROVIDER_UNSPECIFIED",
            "baseName": "PROVIDER_UNSPECIFIED",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAllRegionsResponseRegions.attributeTypeMap;
    }
    constructor() {
    }
}
